import * as styles from "./ToolBar.module.scss";

import React from "react";
import { useClientSide } from "../../hooks/useClientSide";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

export const TOOLBAR_HEIGHT = 60;

export interface ToolBarProps {
	headerHeight: number;
	scrollHeight: number;
	breadcrumbs: DogsTrust.Breadcrumb[];
	isHidden?: boolean;
}

export const ToolBar: React.FC<ToolBarProps> = ({
	headerHeight,
	scrollHeight,
	breadcrumbs,
	isHidden,
}) => {
	const isClientSide = useClientSide();

	if (!isClientSide) {
		return (
			<div
				className={styles.container}
				style={{
					top: headerHeight,
					display: scrollHeight > TOOLBAR_HEIGHT ? "none" : "flex",
				}}
				aria-hidden={isHidden}
			/>
		);
	}
	return (
		<div
			className={styles.container}
			style={{
				top: headerHeight,
				display: scrollHeight > TOOLBAR_HEIGHT ? "none" : "flex",
			}}
			aria-hidden={isHidden}
		>
			<div className={styles.containerinner}>
				<Breadcrumbs breadcrumbs={breadcrumbs} disableLinks={isHidden} />
			</div>
		</div>
	);
};

export default ToolBar;
